module.exports = __webpack_public_path__ + "static/media/truepayWhite.59615006.svg";